import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  IconButton,
  CircularProgress
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch, useSelector } from "react-redux";
import { api } from "../../../redux/api";
import { cloneDeep } from "lodash";
import { treeActions } from "../../../redux/slices/treeSlice";
import { useContext } from "react";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import CommonGrid from "../../Repository/CommonGrid";
import axios from 'axios';
import {
  getRevisionTemplateBodyForSave,
  hasValidRevisionTemplatePayload,
  persistRetrievedRevisionToUserSpace,
} from "../../../utils/persistUserSpaceTemplateFromRevision";

const SCREEN_NAME ={
  inboundTemplate: "inbound_templates/",
  INBOUND: "inbound_templates/",
  outboundTemplate: "outbound_templates/",
  OUTBOUND: "outbound_templates/",
  workflow: "",
  WORKFLOW: ""
}

export const getTemplatePath =(account,workflowGroup,type,title)=>{
  return `${account}/${workflowGroup}/${SCREEN_NAME[type]}${title}.json`;
}
function CustomIconRenderer(params) {
  return (
    <>
      <div style={{ display: "flex" }}>
        <span className={"REVISION_HISTORY"} style={{ margin: "5px" }}></span>
        <p style={{ margin: "0px 5px" }}>{params.value}</p>
      </div>
    </>
  );
}
export default function LocalRevisionHistory(props) {
  const { t } = useTranslation();
  const { openModal, toggle } = props;
  const [commentModal, setCommentModal] = useState({
    isOpen: false,
    data: {},
  });
  const dispatch = useDispatch();
  const [path,setPath] = useState("");
  const [error,setError] = useState("");
  const [oldData,setOldData] = useState(null);
  const [newData,setNewData] = useState(null);
  const [errorModal,setErrorModal] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [rowData, setRowData] = useState([]);
  const [gridApi, setGridApi] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [compareModal, setCompareModal] = useState(false);
  const [htmlContent, setHtmlContent] = useState(null);
  const [diffLoading, setDiffLoading] = useState(false);
  const parentScreen = useContext(ParentScreenCtx);
  const { account, user, baseUrl, token } = useSelector(state => state.queryParams);
  const selectedNode = useSelector(state=>state.treeData[parentScreen].leftTree.tree.body.selectedNode);
  const { type, workflowGroup, title } = selectedNode
  
  const handleCancelClick = () => {
    toggle();
    setSelectedRows([]);
  };
  const errorModalHandler =()=>setErrorModal(!errorModal);
  const compareModalHandler = () => {
    setCompareModal(!compareModal);
    if (!compareModal) {
      setHtmlContent(null);
    }
  };
  const onCommentClose = () =>setCommentModal({ ...commentModal, isOpen: false, data: {} });

  const getGridAPI = (api) => {
    setGridApi(api);
  };

  const gridOptions = {
    columnDefs : [
        {
            headerName:t('COL_SVR_REV_ID'),
            field:'server_revision_id',
            showPlaceholder: false,
            resizable: true,
            cellRenderer:CustomIconRenderer,
            flex:1
        },
        {
            headerName:t('COL_LOCAL_REV_ID'),
            field:'local_revision_id',
            showPlaceholder: false,
            resizable: true,
            flex:1
        },
        {
            headerName:t('DATE_'),
            field:'date',
            showPlaceholder: false,
            resizable: true,
            flex:1
        },
        {
            headerName:t('LBL_NEW_COMMENT'),
            field:'comment',
            showPlaceholder: false,
            resizable: true,
            flex:2
        }
    ],
  };
  
  function onSelectionChanged() {
    const rows = gridApi.getSelectedNodes();

    if(rows.length === 0)
      setSelectedRows([]);

    if(rows.length > 0){
     const rowData= rows?.slice(0, 2).map((row) =>{
       return row.data
      })
      setSelectedRows(rowData)

      rows.slice(2, rows.length).forEach((row) => {
        row.setSelected(false)
      })
    }
  }
  
  const onCellDoubleClicked = (params) => {
    setCommentModal((prevState) => ({
      isOpen: true,
      data:params.data
    }));
  };

  const fetchDiffContent = async (firstRev, secondRev) => {
    setDiffLoading(true);
    try {
      const url = `${baseUrl}/workbench?user=${user}&action=get_server_revision_diff&account=${account}&path=${path}&rev_id1=${firstRev.local_revision_id}&rev_id2=${secondRev.local_revision_id}&ref_id1=${firstRev.server_revision_id}&userspace=true&ref_id2=${secondRev.server_revision_id}`;
      
      const response = await axios(url, {
        responseType: "text",
        headers: { "Authorization": `Bearer ${token}` },
      });
      
      setHtmlContent(response.data);
    } catch (error) {
      console.error("Error fetching diff:", error);
      setHtmlContent(error.response?.data || "Error fetching diff data");
    } finally {
      setDiffLoading(false);
    }
  };

  const compareHandler = () => {
    if (selectedRows.length === 2) {
      const revisionArray = cloneDeep(selectedRows);
      revisionArray.sort((a, b) => {
        const compareFactor1 = +(a.server_revision_id+"."+a.local_revision_id);
        const compareFactor2 = +(b.server_revision_id+"."+b.local_revision_id);
        return compareFactor1 > compareFactor2 ? 1 : -1;
      });
      
      setSelectedRows(revisionArray);
      fetchDiffContent(revisionArray[0], revisionArray[1]);
      compareModalHandler();
    } else {
      setError('BOX_SEL_REV');
      setErrorModal(true);
    }
  };

  const retrieveHandler = () => {
    if (selectedRows.length === 0) {
      setErrorModal(true);
      setError(t("BOX_RETRIEVE_ALERT"));
      return;
    }

    const revisionArray = cloneDeep(selectedRows);

    revisionArray.sort((a, b) => {
      const compareFactor1 = +(
        a.server_revision_id + "." + a.local_revision_id
      );
      const compareFactor2 = +(
        b.server_revision_id + "." + b.local_revision_id
      );
      return compareFactor1 > compareFactor2 ? 1 : -1;
    });

    const rowToRetrieve = revisionArray[revisionArray?.length - 1];
    if (revisionArray?.length > 0) {
      const payloadMap = {
        inbound: "TEMPLATE",
        outbound: "TEMPLATE",
        workflow: "WORKFLOW_DEFINITION",
      };
      dispatch(treeActions.setRightTreeLoading({ screen: parentScreen, data: true }));
      dispatch(
        api.endpoints.get_user_template_by_revision_history_id.initiate({
          account,
          path,
          user,
          revid: rowToRetrieve.server_revision_id,
          user_revid: rowToRetrieve.local_revision_id,
        })
      )
        .then((res) => {
          if (res.error) {
            throw new Error("fetch");
          }
          const templateRecord = res.data;
          if (!hasValidRevisionTemplatePayload(templateRecord)) {
            throw new Error("shape");
          }
          return persistRetrievedRevisionToUserSpace(dispatch, {
            account,
            workflowGroupName: workflowGroup,
            templateName: title,
            templatePath: path,
            templateApiRecord: templateRecord,
          }).then(() => templateRecord);
        })
        .then((templateRecord) => {
          const body = getRevisionTemplateBodyForSave(templateRecord);
          ["header", "body", "trailer"].forEach((e) => {
            dispatch(
              treeActions.setRightTreeSelectedNode({
                screen: parentScreen,
                type: e,
                data: {},
              })
            );
            dispatch(
              treeActions.setRightTreeData({
                screen: parentScreen,
                type: e,
                data: [],
              })
            );
            dispatch(
              treeActions.setNewRightTreeTranslatedData({
                screen: parentScreen,
                type: e,
                data: [],
              })
            );
          });
          dispatch(
            treeActions.setRetrievedData({
              screen: parentScreen,
              [payloadMap[parentScreen]]:
                body.TEMPLATE ?? body.WORKFLOW_DEFINITION,
            })
          );
          dispatch(
            treeActions.setRightTreeLoading({
              screen: parentScreen,
              data: false,
            })
          );
          const listEndpoint =
            parentScreen === "outbound"
              ? "getOutboundTemplateList"
              : parentScreen === "workflow"
                ? "getWorkflows"
                : "getInboundTemplateList";
          return dispatch(
            api.endpoints[listEndpoint].initiate({ account }, { forceRefetch: true })
          );
        })
        .then(() => {
          handleCancelClick();
        })
        .catch(() => {
          dispatch(
            treeActions.setRightTreeLoading({
              screen: parentScreen,
              data: false,
            })
          );
          setError(t("RETRIEVE_ERROR"));
          setErrorModal(true);
        });
    }
  };

  useEffect(() => {
    if(openModal && Object.keys(selectedNode).length>0){

      const path = getTemplatePath(account,workflowGroup,type,title)
      dispatch(api.endpoints.get_user_revision_history.initiate({
        account,
        user,
        path,
      }))
      .then(response=>{
        const data = response.data;
        const updatedRowData = data.map((row, index) => {
          return {
            server_revision_id: row.revisionId === "null" ? "0" : row.revisionId,
            local_revision_id : row.localRevisionId,
            date: row.lastModifiedDate,
            comment: row.comment
          }
        })
        setRowData(updatedRowData)
      })
       .catch((error) => {
        setRowData([error])
       })
       .finally(() => {
         setIsLoading(false)
       })
      setPath(path);

    }
  }, [openModal]);

  return (
    <>
      <Dialog
        open={openModal}
        onClose={handleCancelClick}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth={"md"}
        fullWidth
      >
        <DialogTitle className="dialog-header" id="alert-dialog-title">
         <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div className="title">{t("LBL_LOCAL_USER_REVISION_HISTORY")}</div>
          <IconButton
              onClick={handleCancelClick}
              sx={{ borderRadius: "5px" }}>
              <CloseIcon
                sx={{ height: "28px", width: "28px", color: "#777777" }}
              />
            </IconButton>
         </div>
        </DialogTitle>
        <DialogContent sx={{ height:'100%' }} dividers >
          <div
            className={"dialog-content"}
            style={{ overflow:'hidden' }}
          >
            <span>
              {t("DIAG_REVISION_HISTORY_DESC")}
            </span>
          </div>
          <div style={{ height:'100%' }}>
            <CommonGrid 
              rowData={rowData}
              gridOptions={gridOptions}
              getGridAPI={getGridAPI}
              isLoading={isLoading}
              containerClasses={'server-rev-grid-container'}
              gridProps={{
                animateRows: false,
                enableCellTextSelection: true,
                ensureDomOrder: true,
                rowSelection: "multiple",
                onSelectionChanged: onSelectionChanged,
                onCellDoubleClicked: onCellDoubleClicked,
              }}
              fullSize={true}
             />
          </div>
          <div className={"diag-lrh-ib_footer"} style={{ marginTop: ".5rem" }}>
            <span>{t("DIAG_COMMENT_HINT")}</span>
          </div>
        </DialogContent>

        <DialogActions sx={{ my: 1 }}>
          <Stack direction={"row"} spacing={"8px"}>
            <Button size="small" variant={"outlined"} onClick={compareHandler}>
              {t("BTN_COMPARE")}
            </Button>
            <Button size="small" variant={"outlined"} onClick={retrieveHandler}>
              {t("BTN_RETRIEVE")}
            </Button>
          </Stack>
        </DialogActions>
      </Dialog>
      
      {commentModal.isOpen && (
        <Dialog open={openModal} maxWidth={"xs"} fullWidth onClose={onCommentClose}>
          <DialogTitle>
            <div className="diag-lrh-ib">
              {t('REVISION')} {commentModal.data.revisionId}
            </div>
          </DialogTitle>
          <DialogContent dividers>
            <div
              className={"diag-lrh-ib_header"}
              style={{ marginTop: ".5rem", marginBottom: "1rem" }}
            >
              <span>{t('REVISION')}: {commentModal.data.server_revision_id}</span>
              <span>{t('LOCAL_REVISION')}: {commentModal.data.local_revision_id}</span>
              <span>{t('DATE_')}: {commentModal.data.date}</span>
              <span>{t('COMMENT')}: {commentModal.data.comment}</span>
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              size="small"
              variant={"outlined"}
              onClick={onCommentClose}
            >
              {t("BTN_OK")}
            </Button>
          </DialogActions>
        </Dialog>
      )}

      <Dialog
        open={compareModal}
        onClose={compareModalHandler}
        aria-labelledby="diff-dialog-title"
        aria-describedby="diff-dialog-description"
        maxWidth={"xl"}
        fullWidth
      >
        <DialogTitle>
          <div className="compare-local-revision_header dialog-header">
            <h1>{path}</h1>
          </div>
        </DialogTitle>
        <DialogContent className="compare-local-revisions_body height-100" dividers>
          <div id="local-revision-diff-container" style={{ height: '100%' }}>
            {htmlContent ? (
              <iframe
                srcDoc={htmlContent}
                style={{ width: '100%', height: '100%', border: 'none' }}
                title="HTML Content Viewer"
              ></iframe>
            ) : diffLoading ? (
              <div className='loading-overlay' style={{ marginTop: "15%", display: "grid", gap: "20px" }}>
                <CircularProgress size={"4rem"} />
                <div>{t('LOADING_IND')}</div>
              </div>
            ) : (
              ""
            )}
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            size="small"
            onClick={compareModalHandler}
            variant={"outlined"}
          >
            {t('BTN_CLOSE')}
          </Button>
        </DialogActions>
      </Dialog>

      {errorModal ? (
        <Dialog
          open={errorModal}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle>
            <div className="diag-lrh-ib">{t('ERROR')}</div>
          </DialogTitle>
          <DialogContent dividers>{t(error)}</DialogContent>
          <DialogActions>
            <Button
              size="small"
              onClick={errorModalHandler}
              variant={"outlined"}
            >
              {t("BTN_OK")}
            </Button>
          </DialogActions>
        </Dialog>
      ) : ""}
    </>
  );
}

